import type { Ref } from 'vue';
import {
  computed,
} from 'vue';

import type { DashboardPeriodOptions } from '@modules/dashboard/types';
import type { IFormSelectInputOption } from '@modules/forms/types';
import {
  DASHBOARD_PERIOD_OPTIONS,
} from '@modules/dashboard/constants';
import { useI18n } from '@modules/i18n/composables';

import useDashboardTranslationGroup from './useDashboardTranslationGroup';

export interface DashboardPeriodOptionsComposable {
  periodOptions: Ref<IFormSelectInputOption<DashboardPeriodOptions>[]>;
}

export default function useDashboardPeriodOptions(): DashboardPeriodOptionsComposable {
  const { getTranslation } = useI18n();
  const { translationGroup } = useDashboardTranslationGroup();

  const periodOptions = computed<IFormSelectInputOption<DashboardPeriodOptions>[]>(() => (
    DASHBOARD_PERIOD_OPTIONS.map((v) => ({
      value: v,
      label: getTranslation(translationGroup.value, `PERIODS_${v.toUpperCase()}`).value,
    }))
  ));

  return {
    periodOptions,
  };
}
